<template>
<div id="tencentdoc"></div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { loadMicroApp, initGlobalState } from "qiankun";
import Cookies from "js-cookie";
import mitt from "mitt";
import { mapState, mapActions } from "vuex";
import { getToken, getUserId, getSpaceId, getDeviceId } from "../utils/userInfoUtil";

const microAppName = "tencentdoc.excel";

export default {
  name: "test_vue",
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    fileId: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    belongingFileId: {
      type: String,
      default: ""
    },
    contentType: {
      type: String,
      default: ""
    },
    size: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      bus: null,
      microApp: null
    };
  },
  computed: {
    ...mapState({
      cloudI18n: (state) => state.cloudI18n
    })
  },
  methods: {
    ...mapActions([
    "addDownloadIds"]
    ),
    handleHistory() {
      this.bus.emit("showVersionList");
    },
    handlePrint() {
      this.bus.emit("print");
    },
    async handleSave() {
      return await this.bus.emit("saveVersion");
    },
    async handleExport(type) {
      if (type === "image") {
        this.bus.emit("exportPicture");
      } else if (type === "pdf") {
        if (this.contentType === "MIND" || this.contentType === "FLOW_CHART") {
          this.bus.emit("exportPDF");
          return;
        }
        try {
          const requestPath = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/create/${this.fileId}`;
          const response = await fetch(requestPath, {
            method: 'POST',
            headers: {
              DeviceType: '3',
              'Content-Type': 'application/json',
              token: getToken(this.showtype) || "",
              userId: getUserId(this.showtype) || "",
              spaceId: getSpaceId(this.showtype) || "",
              deviceId: getDeviceId(this.showtype) || ""
            },
            body: JSON.stringify({
              exportFormat: 'PDF'
            })
          });
          if (!response.ok) {
            this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_1"));
            return;
          }

          const data = await response.json();
          if (data.code !== 200) this.$message.error(data.message || intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_2"));
          this.addDownloadIds(this.fileId);
        } catch (error) {
          this.$message.error(intl.$t("导出失败，请重试#!!!#src/pages/H5/Cloud/components/TencentOfficeView.vue_3"));
        }
      } else if (type === "SVG") {
        this.bus.emit('exportSvg');
      } else if (type === "XMIND") {
        this.bus.emit('exportLocalDoc');
      }
    },
    addTencentDocClass() {
      const fileContainer = document.querySelector(".file-container");
      fileContainer.classList.add('tencent-doc-sheet');
      const isSupportWatermark =
      this.contentType === 'WORD' ||
      this.contentType === 'PPT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'TXT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'SMART_SHEET' ||
      this.contentType === 'FLOW_CHART' ||
      this.contentType === 'MIND' ||
      this.contentType === 'BOARD';

      if (!isSupportWatermark) {
        this.removeTencentDocClass();
      }
    },
    removeTencentDocClass() {
      const fileContainer = document.querySelector(".file-container");
      fileContainer.classList.remove('tencent-doc-sheet');
    }
  },
  mounted() {
    this.bus = mitt();
    this.bus?.on('tencentLoadError', (retcode) => {
      if (retcode === 402703) {
        this.$emit('handleGoDownload');
      }
    });
    this.bus?.on('firstScreen', (retcode) => {
      // 通知嵌入当前云文档页面的父窗口，腾讯文档首屏已经完成。
      // fileId 用于知识库切换文档时丢弃旧 iframe 的迟到消息。
      if (window.parent !== window) {
        const parentOrigin = document.referrer ?
        new URL(document.referrer).origin :
        '*';
        const navigation = performance.getEntriesByType('navigation')[0];
        const navigationMetrics = navigation ?
        {
          cloud_navigation_dns: Math.max(0, navigation.domainLookupEnd - navigation.domainLookupStart),
          cloud_navigation_request: Math.max(0, navigation.responseStart - navigation.requestStart),
          cloud_navigation_response: Math.max(0, navigation.responseEnd - navigation.responseStart),
          cloud_navigation_dom_content_loaded: Math.max(0, navigation.domContentLoadedEventEnd),
          cloud_navigation_load_event: Math.max(0, navigation.loadEventEnd)
        } :
        {};
        window.parent.postMessage({
          type: 'firstScreen',
          data: {
            fileId: this.fileId,
            contentType: this.contentType,
            retcode,
            timestamp: Date.now(),
            navigation: navigationMetrics
          }
        }, parentOrigin);
      }
    });
    const actions = initGlobalState({});
    let propsMap = {
      actions,
      userInfo: {
        ...this.userInfo,
        token: Cookies.get("token") || ""
      },
      fileId: this.fileId,
      bus: this.bus,
      language: this.cloudI18n,
      envPath: process.env.VUE_APP_BASE_URL,
      propsDocsConfig: {
        toolbar: !this.isPreview
      },
      uiService: {
        message: this.$message
      }
    };
    //处理预览逻辑，强制只读
    if (this.isPreview === true) {
      propsMap = {
        ...propsMap,
        readonly: this.isPreview
      };
    }
    //处理附件预览逻辑
    if (this.belongingFileId && this.belongingFileId.length > 0) {
      propsMap = {
        ...propsMap,
        belongingFileId: this.belongingFileId
      };
    }

    this.microApp = loadMicroApp({
      name: microAppName,
      entry: "https://m.elongstatic.com/toca_tencent_doc/0.5.0/index.html",
      // entry: "http://10.161.120.68:8080/",
      container: "#tencentdoc",
      activeRule: () => true,
      props: propsMap
    });
    // 腾讯表格隐藏管家水印
    this.addTencentDocClass();

    // 处理预览or下载逻辑
    const isSupportedInlineType =
    this.contentType === 'WORD' ||
    this.contentType === 'PPT' ||
    this.contentType === 'PDF' ||
    this.contentType === 'EXCEL';

    if (!isSupportedInlineType) {
      if (this.size > 100 * 1024 * 1024) {
        this.$emit("handleGoDownload");
      }
    }
  },
  beforeDestroy() {
    this.bus?.off('tencentLoadError');
    this.bus?.off('firstScreen');
    this.bus = null;
    if (this.microApp && this.microApp.unmount) {
      this.microApp.unmount();
      this.microApp = null;
    }
    this.removeTencentDocClass();
  }
};
</script>

<style lang="scss" scoped>
#tencentdoc {
  width: 100%;
  height: 100%;
}
</style>

<style>
.tencent-doc-sheet #water-mark-cloud {
  opacity: 0 !important;
}
</style>
